import { Box, Text } from '@factorialco/deprecated-design-system'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import {
  ReconciliationItem,
  ReconciliationSource,
} from 'modules/banking/hooks/useReconciliationForm'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

interface SummaryTotalsRowProps {
  locale: string
  reconciliations: ReconciliationItem[]
  source: ReconciliationSource | null | undefined
}

export const SummaryTotalsRow = ({ locale, reconciliations, source }: SummaryTotalsRowProps) => {
  const itemsTotalAmount: { credit: string; debit: string } = useUnsafeMemo(() => {
    let debitItemsAmount = reconciliations.reduce((acc, el) => {
      return el.type === 'debit' ? acc + el.amountCentsToReconcile : acc
    }, 0)
    let creditItemsAmount = reconciliations.reduce((acc, el) => {
      return el.type === 'credit' ? acc + el.amountCentsToReconcile : acc
    }, 0)

    if (source?.type == 'debit') {
      debitItemsAmount += source?.amountCentsToReconcile || 0
    }
    if (source?.type == 'credit') {
      creditItemsAmount += source?.amountCentsToReconcile || 0
    }

    const formattedDebitAmounts = formattedAmount({
      amountCents: debitItemsAmount,
      currency: source?.currency || 'EUR',
      locale,
    })
    const formattedCreditAmounts = formattedAmount({
      amountCents: creditItemsAmount,
      currency: source?.currency || 'EUR',
      locale,
    })

    return {
      debit:
        formattedDebitAmounts ||
        formattedAmount({ amountCents: 0, currency: source?.currency || 'EUR', locale }),
      credit:
        formattedCreditAmounts ||
        formattedAmount({ amountCents: 0, currency: source?.currency || 'EUR', locale }),
    }
  }, [reconciliations, locale, source])

  return (
    <Box
      width="full"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      style={{ minHeight: '20px' }}
    >
      <Box flexDirection="row" gap="s48">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {i18n.t('banking.reconciliations.total_summary.totals')}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween" width="s240" paddingRight="s40">
        <Box textAlign="right" width="s120" justifyContent="center">
          <Text.Normal size="200" weight="medium" color="grey800" whiteSpace="breakSpaces">
            {itemsTotalAmount['debit']}
          </Text.Normal>
        </Box>
        <Box textAlign="right" width="s120" justifyContent="center">
          <Text.Normal size="200" weight="medium" color="grey800" whiteSpace="breakSpaces">
            {itemsTotalAmount['credit']}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}
